/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Revenue_AccountInputs */

const en_admin_resource_form_revenue_account = /** @type {(inputs: Admin_Resource_Form_Revenue_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenue account`)
};

const de_admin_resource_form_revenue_account = /** @type {(inputs: Admin_Resource_Form_Revenue_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erlöskonto`)
};

const es_admin_resource_form_revenue_account = /** @type {(inputs: Admin_Resource_Form_Revenue_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta de ingresos`)
};

const fr_admin_resource_form_revenue_account = /** @type {(inputs: Admin_Resource_Form_Revenue_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte de recettes`)
};

/** @type {(inputs: Admin_Resource_Form_Revenue_AccountInputs) => LocalizedString} */
const it_admin_resource_form_revenue_account = en_admin_resource_form_revenue_account;

/** @type {(inputs: Admin_Resource_Form_Revenue_AccountInputs) => LocalizedString} */
const pt_br2_admin_resource_form_revenue_account = en_admin_resource_form_revenue_account;

/** @type {(inputs: Admin_Resource_Form_Revenue_AccountInputs) => LocalizedString} */
const pl_admin_resource_form_revenue_account = en_admin_resource_form_revenue_account;

/** @type {(inputs: Admin_Resource_Form_Revenue_AccountInputs) => LocalizedString} */
const hu_admin_resource_form_revenue_account = en_admin_resource_form_revenue_account;

/** @type {(inputs: Admin_Resource_Form_Revenue_AccountInputs) => LocalizedString} */
const ro_admin_resource_form_revenue_account = en_admin_resource_form_revenue_account;

/**
* | output |
* | --- |
* | "Revenue account" |
*
* @param {Admin_Resource_Form_Revenue_AccountInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_revenue_account = /** @type {((inputs?: Admin_Resource_Form_Revenue_AccountInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Revenue_AccountInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_revenue_account(inputs)
	if (locale === "de") return de_admin_resource_form_revenue_account(inputs)
	if (locale === "es") return es_admin_resource_form_revenue_account(inputs)
	if (locale === "fr") return fr_admin_resource_form_revenue_account(inputs)
	if (locale === "it") return it_admin_resource_form_revenue_account(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_revenue_account(inputs)
	if (locale === "pl") return pl_admin_resource_form_revenue_account(inputs)
	if (locale === "hu") return hu_admin_resource_form_revenue_account(inputs)
	return ro_admin_resource_form_revenue_account(inputs)
});
export { admin_resource_form_revenue_account as "admin.resource_form.revenue_account" }